export default __webpack_public_path__ + "static/media/lk.d4485c4a.svg";